import '@babel/polyfill'

import { createApp } from 'vue'
import SherpaCrmApp from '@/components/SherpaCrmApp'
import { router } from '@/router/'
import store from '@/store'
import language from '@/language'
import DatePicker from 'vue-datepicker-next'
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import FloatingVue from 'floating-vue'
import VueMasonry from 'vue-masonry-css'
import VueApexCharts from 'vue3-apexcharts'
import PrettyCheck from '@/components/shared/PrettyCheck.vue'
import PrettyRadio from '@/components/shared/PrettyRadio.vue'
import 'vue-datepicker-next/index.css'
import 'floating-vue/dist/style.css'

const app = createApp(SherpaCrmApp)

app.config.globalProperties.sherpaCrm = process.env

app.use(store)
app.use(router)
app.use(language)
app.use(FloatingVue)
app.use(VueMasonry)
app.use(VueApexCharts)

app.component('date-picker', DatePicker)
app.component('spinner-loading', SpinnerLoading)
app.component('p-check', PrettyCheck)
app.component('p-radio', PrettyRadio)


app.mount('sherpa-crm-app')
